'use client';
import { Entering, TabBar, Typography } from 'components';
import { RoleEnum } from 'gql/graphql';
import useTabs from 'hooks/useTabs';
import { useTranslations } from 'next-intl';
import { useClientAdmin } from 'providers/UserProvider/useClientAdmin';
import { useCurrentUser } from 'providers/UserProvider/useCurrentUser';
import { FC, PropsWithChildren } from 'react';
import { cn } from 'utils/cn';
import RemoveAccount from './_component/RemoveAccount';

const AccountDetailsLayout: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const t = useTranslations();
  const { data } = useClientAdmin();
  const { data: currentUser } = useCurrentUser();

  const { tabs, activeTabIndex } = useTabs({
    context: 'account_details',
    routes: [
      'general',
      'security',
      ...(data?.allowedToHaveEditors && currentUser?.role === RoleEnum.Manager ? ['manage'] : [])
    ]
  });

  return (
    <>
      <div
        className={cn(
          'w-7xl sticky top-20 z-50 w-[calc(100%_-_4px)] max-w-7xl bg-[hsl(200deg_60%_98.04%_/_0%)]',
          'backdrop-blur-md transition-colors duration-200 ease-in-out',
          'pt-10 md:ml-1 md:pl-3 md:pr-8 lg:ml-1 lg:pl-[28px] lg:pr-8'
        )}
      >
        <Entering position="top" delay={0} duration={0.2} offset={20}>
          <div className="flex w-full justify-between ">
            <Typography
              variant="medium7xl"
              className="relative left-0 top-0 text-tertiary-100 dark:text-white"
            >
              {t('account_details.title')}
            </Typography>
            <RemoveAccount />
          </div>
        </Entering>
        <TabBar tabs={tabs} activeTabIndex={activeTabIndex} />
      </div>
      <Entering position="top" delay={0.6} duration={0.2} offset={20}>
        <div className="md:mx-4 lg:mx-8">{children}</div>
      </Entering>
    </>
  );
};

export default AccountDetailsLayout;
